import { Action } from '@ngrx/store';
import { User } from '@core/objects/user';
import { UserRequest } from '@core/objects/user-request';
import { HttpErrorResponse } from '@angular/common/http';

import { SeatSetting } from '@core/objects/seat';

export enum SettingsUsersActionType {

	// EVENT CALLS
	LoadAllUsers= "[SettingsUsers] GET - Obtain all users",
	LoadAllUsersSuccess= "[SettingsUsers] - Obtain all users SUCCESS",
	LoadAllUsersError= "[SettingsUsers] - Obtain all users ERROR",

	// LoadAllInvitations = "[SettingsUsers] GET - Obtain all invitations",
	// LoadAllInvitationsSuccess = "[SettingsUsers] - Obtain all invitations SUCCESS",
	// LoadAllInvitationsError = "[SettingsUsers] - Obtain all invitations ERROR",

	AddNewInvitation = "[SettingsUsers] POST - Create new invitation",
	AddNewInvitationSuccess = "[SettingsUsers] - Create new invitation SUCCESS",
	AddNewInvitationError = "[SettingsUsers] - Create new invitation ERROR",
	ClearAddInvitation = "[SettingsUsers] Clean new invitation http status on the store",

	DeleteOneUser = "[SettingsUsers] DELETE - Remove user",
	DeleteOneUserSuccess = "[SettingsUsers] - Remove user SUCCESS",
	DeleteOneUserError = "[SettingsUsers] - Remove user ERROR",
	ClearDeleteUSer = "[SettingsUsers] Clean delete user action http status on the store",

	DeleteInvitation = '[SettingsUsers] DELETE - Cancel invitation',
	DeleteInvitationSuccess = '[SettingsUsers] - Cancel invitation SUCCESS',
	DeleteInvitationError = '[SettingsUsers] - Cancel invitation ERROR',
	ClearDeleteInvitation = "[SettingsUsers] Clean cancel invitation http status on the store",

	// SET STORE
	SetAllUsers = "[SettingsUsers] - Set all users in the store",
	SetAllInvitations = "[SettingsUsers] - Set all invitations in the store",
	CreateNewUser = "[SettingsUsers] - Add new user in the store",

	// FOR SEATS
	LoadAllUsersSeats = "[SettingsUsersSeats] GET - Obtain all Seats",
	LoadAllUsersSeatsSuccess = "[SettingsUsersSeats] - Obtain all Seats SUCCESS",
	LoadAllUsersSeatsError = "[SettingsUsersSeats] - Obtain all Seats ERROR",

	SetAllUsersSeats = "[SettingsUsersSeats] - Set all seats in the store",
}

// LOAD-USERS
export class LoadAllUsers implements Action {
    readonly type = SettingsUsersActionType.LoadAllUsers;
    constructor() {}
}
export class LoadAllUsersSuccess implements Action {
    readonly type = SettingsUsersActionType.LoadAllUsersSuccess;
    constructor(public users: User[]) {}
}
export class LoadAllUsersError implements Action {
    readonly type = SettingsUsersActionType.LoadAllUsersError;
    constructor() {}
}

// ADD-INVITATION
export class AddNewInvitation implements Action {
    readonly type = SettingsUsersActionType.AddNewInvitation;
    constructor(public name:string, public email:string, public message:string, public groups:Array<number>, public extra: any) {}
}
export class AddNewInvitationSuccess implements Action {
    readonly type = SettingsUsersActionType.AddNewInvitationSuccess;
    constructor() {}
}
export class AddNewInvitationError implements Action {
    readonly type = SettingsUsersActionType.AddNewInvitationError;
    constructor(public error? : HttpErrorResponse) {}
}

export class ClearAddInvitation implements Action {
	readonly type = SettingsUsersActionType.ClearAddInvitation;
	constructor() {}
}

// DELETE-USER
export class DeleteOneUser implements Action {
    readonly type = SettingsUsersActionType.DeleteOneUser;
    constructor(public id: string) {}
}
export class DeleteOneUserSuccess implements Action {
    readonly type = SettingsUsersActionType.DeleteOneUserSuccess;
    constructor() {}
}
export class DeleteOneUserError implements Action {
    readonly type = SettingsUsersActionType.DeleteOneUserError;
    constructor() {}
}
export class ClearDeleteUSer implements Action {
	readonly type = SettingsUsersActionType.ClearDeleteUSer;
	constructor() {}
}

// DELETE-INVITATION
export class DeleteInvitation implements Action {
    readonly type = SettingsUsersActionType.DeleteInvitation;
    constructor(public email: string) {}
}
export class DeleteInvitationSuccess implements Action {
    readonly type = SettingsUsersActionType.DeleteInvitationSuccess;
    constructor() {}
}
export class DeleteInvitationError implements Action {
    readonly type = SettingsUsersActionType.DeleteInvitationError;
    constructor() {}
}
export class ClearDeleteInvitation implements Action {
	readonly type = SettingsUsersActionType.ClearDeleteInvitation;
	constructor() {}
}

// SEATS
export class LoadAllUsersSeats implements Action {
	readonly type = SettingsUsersActionType.LoadAllUsersSeats;
	constructor() {}
}
export class LoadAllUsersSeatsSuccess implements Action {
	readonly type = SettingsUsersActionType.LoadAllUsersSeatsSuccess;
	constructor(public seats: SeatSetting[]) {}
}
export class LoadAllUsersSeatsError implements Action {
	readonly type = SettingsUsersActionType.LoadAllUsersSeatsError;
	constructor(public error: any) {}
}

// STORE
export class SetAllUsers implements Action {
	readonly type = SettingsUsersActionType.SetAllUsers;
	constructor(public users: User[]){}
}

export class CreateNewUser implements Action {
	readonly type = SettingsUsersActionType.CreateNewUser;
	constructor(public invitation: UserRequest){}
}


export class SetAllUsersSeats implements Action {
	readonly type = SettingsUsersActionType.SetAllUsersSeats;
	constructor(public seats: SeatSetting[]){}
	}

export type SettingsUsersActions = 	LoadAllUsers |
									LoadAllUsersSuccess |
									LoadAllUsersError |

									AddNewInvitation |
									AddNewInvitationSuccess |
									AddNewInvitationError |
									ClearAddInvitation |

									DeleteOneUser |
									DeleteOneUserSuccess |
									DeleteOneUserError |
									ClearDeleteUSer |

									DeleteInvitation |
									DeleteInvitationSuccess |
									DeleteInvitationError |
									ClearDeleteInvitation |

									// SEATS
									LoadAllUsersSeats |
									LoadAllUsersSeatsSuccess |
									LoadAllUsersSeatsError |

									// SET STORE
									SetAllUsers |
									CreateNewUser |
								
									SetAllUsersSeats;
